import { render, staticRenderFns } from "./Fellowship.vue?vue&type=template&id=470e50be&scoped=true&"
import script from "./js/fellowship.js?vue&type=script&lang=js&"
export * from "./js/fellowship.js?vue&type=script&lang=js&"
import style0 from "./Fellowship.vue?vue&type=style&index=0&id=470e50be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470e50be",
  null
  
)

export default component.exports